import React, { Component } from "react";
import CommonTree from '../models/commonTree'
type iContext = {
  zoneList:CommonTree[],
  enumData: any
};
const AppContext:React.Context<iContext> = React.createContext({
  zoneList: [],
  enumData: {}
});
export default AppContext
